import React, { useState, useEffect, useCallback } from "react";
import { MyInput, Spinner } from "../../../../components";
import $ from "jquery";
import { Slang } from "../../../../helpers";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import config from "../../../../config";
import Dashboard from "../../../../layouts/dashboard";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { useDropzone } from "react-dropzone";

import {
  GoogleReCaptcha,
  GoogleReCaptchaProvider,
} from "react-google-recaptcha-v3";

const AddProduct = () => {
  const [loadPage, setLoadPage] = useState(true);

  useEffect(() => {
    let tim1 = setTimeout(() => {
      setLoadPage(false);
    }, 100);

    const script = `
        new HSGoTo('.js-go-to');
        new HSHeader('#header').init();
        new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
    `;

    $("body").append(`<script className="homescript">${script}</script>`);

    return () => {
      clearTimeout(tim1);
      $(".homescript").remove();
    };
  }, []);

  return (
    <>
      {loadPage ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
            position: "fixed",
            left: 0,
            top: 0,
          }}
        >
          <Spinner color={"success"} size={3} />
        </div>
      ) : (
        <Main />
      )}
    </>
  );
};

export default AddProduct;

const Main = () => {
  const [tokenReCaptcha, setToken] = useState(null);
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [categories, setCategories] = useState(null);
  const [suppliers, setSuppliers] = useState(null);
  const [images, setImages] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    category_product_id: "",
    currency: "",
    price: "",
    stock: "",
    supplier_id: null, 
    images: []
  });
  const [categoryName, setCategoryName] = useState("");

  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token.value);
  const navigate = useNavigate();

  const lang1 = Slang("Product.add");

  const getCategories = async () => {
    const { data } = await axios.get(`${config.apiUrl}/products/categories`, {});
    setCategories(data.data);
  };

  const getSuppliers = async () => {
    const { data } = await axios.get(`${config.apiUrl}/suppliers`, {});
    setSuppliers(data.data.suppliers);
    console.log(data.data.suppliers);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const onVerify = useCallback((token$) => {
    sessionStorage.setItem("reCaptchaToken", token$);
    setToken(token$);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("name", formData.name);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("category_product_id", formData.category_product_id);
      formDataToSend.append("currency", formData.currency);
      formDataToSend.append("price", formData.price);
      formDataToSend.append("stock", formData.stock);

      if (user.roles[0].name === "company") {
        formDataToSend.append("company_id", user.company[0].id);
      }

      if (user.roles[0].name === "company" && formData.supplier_id) {
        formDataToSend.append("supplier_id", formData.supplier_id);
      }

      if (user.supplier) {
        formDataToSend.append("supplier_id", user.supplier.id);
      }

      images.forEach((image, index) => {
        formDataToSend.append(`images[${index}]`, image);
      });

      const response = await axios.post(
        `${config.apiUrl}/add/products`,
        formDataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setSubmitted(false);
      toast.success(lang1("success"));
      setTimeout(() => {
        navigate("/product_managment/list");
      }, 5000);
    } catch (error) {
      setSubmitted(false);
      toast.error(lang1("error"));
      setRefreshReCaptcha((r) => !r);
      console.log(error);
    }
  };

  useEffect(() => {
    getCategories();

    if (user.supplier) {
      setFormData((prevData) => ({
        ...prevData,
        supplier_id: user.supplier.id,
      }));
    } else {
      getSuppliers();
    }
  }, []);

  const handleDrop = (acceptedFiles) => {
    setImages((prevImages) => [...prevImages, ...acceptedFiles]);
    setFormData((prevData) => ({
      ...prevData,
      images: [...prevData.images, ...acceptedFiles],
    }));
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleDrop,
    accept: "image/*",
  });

  const handleSubmitCategory = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${config.apiUrl}/add/categories`,
        {
          name: categoryName,
          company_id: user.account.company_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      getCategories();
      setCategoryName("");
      $("#addCategoryModal").modal("hide");
    } catch (error) {
      console.error("Error creating category:", error);
    }
  };

  return (
    <Dashboard>
      <main id="content" role="main">
        <div
          className="content-space-6 content-space-t-lg-1 content-space-b-lg-3"
          style={{ maxWidth: "100rem" }}
        >
          <div className="flex-grow-1 mx-auto " style={{ maxWidth: "100rem" }}>
            <form onSubmit={handleSubmit}>
              <fieldset
                style={{
                  borderRadius: 5,
                  color: "black",
                  boxShadow: "2px 2px 1px rgba(0, 0, 0, 0.01)",
                }}
              >
                {user.account.type_account === "company" && (
                  <div className="row mb-3">
                    <div className="col-12">
                      <legend className="fw-semibold opacity-50">
                        Select a supplier
                      </legend>
                      <select
                        name="supplier_id"
                        id="supplier_id"
                        onChange={handleChange}
                        className="form-control form-control-lg"
                        required
                      >
                        <option value={null}> -- --</option>
                        {suppliers !== null
                          ? suppliers.map((supplier, idx) => (
                              <option
                                key={idx + "-" + supplier.supplier.id}
                                value={supplier.supplier.id}
                              >
                                {supplier.email}
                              </option>
                            ))
                          : null}
                      </select>
                    </div>
                  </div>
                )}

                <div className="row mb-3">
                  <div className="col-12">
                    <legend className="fw-semibold opacity-50">Name</legend>
                    <MyInput
                      handleChange={handleChange}
                      required={true}
                      id="name"
                      name="name"
                      placeholder={lang1("t1")}
                      type="text"
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-12">
                    <legend className=" fw-semibold opacity-50">
                      Description
                    </legend>
                    <textarea
                      className="form-control"
                      id="description"
                      name="description"
                      onChange={handleChange}
                      rows="6"
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <legend className=" fw-semibold opacity-50">
                      Category
                    </legend>
                    <select
                      name="category_product_id"
                      id="category_product_id"
                      onChange={handleChange}
                      className="form-control form-control-lg"
                      required
                    >
                      <option value={null}> -- --</option>
                      {categories !== null
                        ? categories.map((category, idx) => (
                            <option
                              key={idx + "-" + category.id}
                              value={category.id}
                            >
                              {category.name}
                            </option>
                          ))
                        : null}
                    </select>
                  </div>

                  {/* <div className="row mb-4"> */}
                  <div className="col-md-6">
                    <legend className=" fw-semibold opacity-50">Stock</legend>
                    <MyInput
                      handleChange={handleChange}
                      required={true}
                      id="stock"
                      name="stock"
                      placeholder={lang1("t3")}
                      type="text"
                    />
                  </div>
                {/* </div> */}
                </div>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <legend className=" fw-semibold opacity-50">
                      Price
                    </legend>
                    <MyInput
                      handleChange={handleChange}
                      required={true}
                      id="price"
                      name="price"
                      placeholder={lang1("t2")}
                      type="number"
                    />
                  </div>
                  <div className="col-md-6">
                    <legend className=" fw-semibold opacity-50">
                      Currency
                    </legend>
                    <select
                      name="currency"
                      id="currency"
                      onChange={handleChange}
                      className="form-control form-control-lg"
                      required
                    >
                      <option value={null}> -- --</option>
                      <option value="USD"> USD</option>
                      <option value="XAF"> XAF</option>
                      <option value="XOF"> XOF</option>
                      <option value="EURO"> EURO</option>
                      <option value="CAD"> CAD</option>
                    </select>
                  </div>
                </div>

                

                <div className="row mb-4">
                  <div className="col-md-12">
                    <legend className="fw-semibold opacity-50">
                      Upload Images
                    </legend>
                    <div
                      {...getRootProps()}
                      className={`form-control p-8 border-dashed ${
                        isDragActive ? "border-secondary" : ""
                      }`}
                      style={{ textAlign: "center", cursor: "pointer" }}
                    >
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        <p>Drop the files here ...</p>
                      ) : (
                        <p>
                          Drag & drop some files here, or click to select files
                        </p>
                      )}
                      <FaPlus className="text-info" size={20} />
                    </div>
                    {images.length > 0 && (
                      <div className="mt-3">
                        <ul>
                          {images.map((file, index) => (
                            <li key={index}>{file.name}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-12 d-flex ">
                    <button
                      type="submit"
                      className="btn btn-lg btn-block btn-primary"
                      disabled={submitted}
                    >
                      {submitted ? (
                        <span>
                          <Spinner color={"light"} /> Saving...
                        </span>
                      ) : (
                        "Save"
                      )}
                    </button>

                    <button
                  type="button"
                  className="btn btn-danger mx-2"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </main>
    </Dashboard>
  );
};



// import React, { useState, useEffect, useCallback } from "react";
// import { MyInput, Spinner } from "../../../../components";
// import $ from "jquery";
// import { Slang } from "../../../../helpers";
// import axios from "axios";
// import { useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import config from "../../../../config";
// import Dashboard from "../../../../layouts/dashboard";
// import { useNavigate } from "react-router-dom";
// import { FaPlus } from "react-icons/fa";

// import {
//   GoogleReCaptcha,
//   GoogleReCaptchaProvider,
// } from "react-google-recaptcha-v3";

// const AddProduct = () => {
//   const [loadPage, setLoadPage] = useState(true);

//   useEffect(() => {
//     let tim1 = setTimeout(() => {
//       setLoadPage(false);
//     }, 100);

//     const script = `
//         new HSGoTo('.js-go-to');
//         new HSHeader('#header').init();
//         new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
//     `;

//     $("body").append(`<script className="homescript">${script}</script>`);

//     return () => {
//       clearTimeout(tim1);
//       $(".homescript").remove();
//     };
//   }, []);

//   return (
//     <>
//       {loadPage ? (
//         <div
//           style={{
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "center",
//             alignItems: "center",
//             height: "100vh",
//             width: "100%",
//             position: "fixed",
//             left: 0,
//             top: 0,
//           }}
//         >
//           <Spinner color={"success"} size={3} />
//         </div>
//       ) : (
//         <Main />
//       )}
//     </>
//   );
// };

// export default AddProduct;

// const Main = () => {
//   const [tokenReCaptcha, setToken] = useState(null);
//   const [refreshReCaptcha, setRefreshReCaptcha] = useState(null);
//   const [submitted, setSubmitted] = useState(false);
//   const [categories, setCategories] = useState(null);
//   // const [currencies, setCurrencies] = useState(null);
//   const [suppliers, setSuppliers] = useState(null);
//   const [ images, setImages ] = useState([]);
//   const [formData, setFormData] = useState({
//     name: "",
//     description: "",
//     category_product_id: "",
//     currency: "",
//     price: "",
//     stock: "",
//     supplier_id: null, // Initialize supplier_id as null
//     image: "",
//     images: images
//   });
//   const [categoryName, setCategoryName] = useState("");

//   // user connected
//   const user = useSelector((state) => state.auth.user);
//   console.log("user in add product", user);

//   const token = useSelector((state) => state.auth.token.value);
//   const navigate = useNavigate();

//   const lang1 = Slang("Product.add");
//   // const lang2 = Slang("Validation.product");

//   const getCategories = async () => {
//     const { data } = await axios.get(
//       `${config.apiUrl}/products/categories`,
//       {}
//     );
//     setCategories(data.data);
//     console.log(data);
//   };

//   const getSuppliers = async () => {
//     const { data } = await axios.get(`${config.apiUrl}/suppliers`, {});
//     setSuppliers(data.data.suppliers);
//     console.log(data.data.suppliers);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const onVerify = useCallback((token$) => {
//     sessionStorage.setItem("reCaptchaToken", token$);
//     setToken(token$);
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitted(true);

//     try {
//       const formDataToSend = new FormData();
//       formDataToSend.append("name", formData.name);
//       formDataToSend.append("description", formData.description);
//       formDataToSend.append(
//         "category_product_id",
//         formData.category_product_id
//       );
//       formDataToSend.append("currency", formData.currency);
//       formDataToSend.append("price", formData.price);
//       formDataToSend.append("stock", formData.stock);

//       // Send company ID if user is a company
//       if (user.roles[0].name === "company") {
//         formDataToSend.append("company_id", user.company[0].id);
//       }

//       // Send supplier ID if user is a company and selected a supplier
//       if (user.roles[0].name === "company" && formData.supplier_id) {
//         formDataToSend.append("supplier_id", formData.supplier_id);
//       }

//       // Send supplier ID if user is a supplier
//       if (user.supplier) {
//         formDataToSend.append("supplier_id", user.supplier.id);
//       }

//       formDataToSend.append("image", formData.image);
//       console.log("to send", formDataToSend);

//       const response = await axios.post(
//         `${config.apiUrl}/add/products`,
//         formDataToSend,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//       setSubmitted(false);
//       toast.success(lang1("success"));
//       setTimeout(() => {
//         navigate("/product_managment/list");
//       }, 5000);
//     } catch (error) {
//       setSubmitted(false);
//       toast.error(lang1("error"));
//       setRefreshReCaptcha((r) => !r);
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     getCategories();

//     // Pre-fill supplier ID if user is a supplier
//     if (user.supplier) {
//       setFormData((prevData) => ({
//         ...prevData,
//         supplier_id: user.supplier.id,
//       }));
//     } else {
//       getSuppliers();
//     }
//   }, []);

//   const handleSubmitCategory = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(
//         `${config.apiUrl}/add/categories`,
//         {
//           name: categoryName,
//           company_id: user.account.company_id,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       // Handle successful category creation
//       console.log("Category created successfully:", response.data);
//       // Update categories state or refresh the category list
//       getCategories();
//       setCategoryName("");
//       $("#addCategoryModal").modal("hide"); // Assuming you're using Bootstrap
//     } catch (error) {
//       console.error("Error creating category:", error);
//       // Handle the error appropriately (e.g., display an error message)
//     }
//   };

//   return (
//     <Dashboard>
//       <main id="content" role="main">
//         <div
//           className=" content-space-6 content-space-t-lg-1 content-space-b-lg-3"
//           style={{ maxWidth: "100rem" }}
//         >
//           <div className="flex-grow-1 mx-auto " style={{ maxWidth: "100rem" }}>
//             <form onSubmit={handleSubmit}>
//               <fieldset
//                 style={{
//                   borderRadius: 5,
//                   color: "black",
//                   boxShadow: "2px 2px 1px rgba(0, 0, 0, 0.01)",
//                   background: "",
//                 }}
//               >
//                 {/* <legend className="fw-bold">{lang1("title")}</legend> */}

//                 {user.account.type_account === "company" && (
//                   <div className="row mb-3">
//                     <div className="col-12">
//                       {/* <label
//                         className="form-label text-primary fw-bold"
//                         htmlFor="supplier_id"
//                       >
//                         {lang1("t7")}
//                         Select a Supplier
//                       </label> */}
//                       <legend className="fw-semibold opacity-50">
//                         Select a supplier{" "}
//                       </legend>

//                       <select
//                         name="supplier_id"
//                         id="supplier_id"
//                         onChange={handleChange}
//                         className="form-control form-control-lg"
//                         required
//                       >
//                         <option value={null}> -- --</option>
//                         {suppliers !== null
//                           ? suppliers.map((supplier, idx) => (
//                               <option
//                                 key={idx + "-" + supplier.id}
//                                 value={supplier.id}
//                               >
//                                 {supplier.name}
//                               </option>
//                             ))
//                           : null}
//                       </select>
//                     </div>
//                   </div>
//                 )}

//                 <div className="row mb-3">
//                   <div className="col-12">
//                     <legend className="fw-semibold opacity-50">Name</legend>
//                     <MyInput
//                       // label={lang1("t1")}
//                       // label={"name"}
//                       handleChange={handleChange}
//                       required={true}
//                       id="name"
//                       name="name"
//                       // value={formData.name}
//                       placeholder={lang1("t1")}
//                       type="text"
//                     />
//                   </div>
//                 </div>

//                 <div className="row mb-4">
//                   <div className="col-12">
//                     {/* <label className="form-label text-primary fw-bold"> */}
//                     {/* {lang1("t2")} */}
//                     {/* description
//                     </label> */}
//                     <legend className=" fw-semibold opacity-50">
//                       Description
//                     </legend>

//                     <textarea
//                       className="form-control"
//                       id="description"
//                       name="description"
//                       // value={formData.description}
//                       // placeholder={lang1("t2")}
//                       onChange={handleChange}
//                       rows="6"
//                     />
//                   </div>
//                 </div>

//                 <div className="row mb-4">
//                   <div className="col-12">
//                     {/* <label className="form-label text-primary fw-bold">
//                       {lang1("t3")}
//                     </label> */}
//                     <legend className="fw-semibold opacity-50">
//                       Select an image
//                     </legend>
//                     <input
//                       type="file"
//                       className="form-control"
//                       id="image"
//                       name="image"
//                       onChange={(e) => {
//                         setFormData({
//                           ...formData,
//                           image: e.target.files[0],
                          
//                         });
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <div className="row mb-3">
//                   <div className=" col-md-6 col-sm-12">
//                     {/* <label
//                       className="form-label text-primary fw-bold"
//                       htmlFor="category_product_id"
//                     >
//                       {lang1("t3")}
//                     </label> */}
//                     <div className="row">
//                       <legend className="fw-semibold opacity-50">
//                         Category
//                       </legend>
//                       <div className="col-md-9 col-lg-10">
//                         <select
//                           name="category_product_id"
//                           id="category_product_id"
//                           onChange={handleChange}
//                           className="form-control form-control-lg"
//                         >
//                           <option value={null}> -- --</option>
//                           {categories !== null
//                             ? categories.map((category, idx) => (
//                                 <option key={idx} value={category.id}>
//                                   {category.name}
//                                 </option>
//                               ))
//                             : null}
//                         </select>
//                       </div>

//                       <div className="col-md-3 col-lg-2 ">
//                         <button
//                           className=" border btn btn-info d-flex align-items-center w-100 justify-content-center"
//                           // onClick={null}
//                           type="button"
//                           data-bs-toggle="modal"
//                           data-bs-target="#addCategoryModal"
//                         >
//                           <FaPlus size={12} />{" "}
//                           <span className=" ms-1"> Add </span>
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-md-6 col-sm-12">
//                     <legend className="fw-semibold opacity-50">Currency</legend>
//                     {/* <label
//                       className="form-label text-primary fw-bold"
//                       htmlFor="currency"
//                     >
//                       {lang1("t4")}
//                     </label> */}
//                     {/* <select
//                       name="currency"
//                       id="currency"
//                       onChange={handleChange}
//                       className="form-control form-control-lg"
//                     >
//                       <option value={null}> -- --</option>
//                       {currencies !== null
//                         ? currencies.map((currency, idx) => (
//                             <option key={idx} value={currency.id}>
//                               {currency.name}
//                             </option>
//                           ))
//                         : null}
//                     </select> */}
//                     <MyInput
//                       handleChange={handleChange}
//                       required={true}
//                       id="currency"
//                       name="currency"
//                       // value={formData.currency}
//                       placeholder={"USD , EUR, GBP, etc."}
//                       // placeholder={lang1("t5")}
//                       type="text"
//                     />
//                   </div>
//                 </div>

//                 <div className="row mb-3">
//                   <div className="col-md-6 col-sm-12">
//                     <legend className="fw-semibold opacity-50">Price</legend>

//                     <MyInput
//                       // label={lang1("t5")}
//                       handleChange={handleChange}
//                       required={true}
//                       id="price"
//                       name="price"
//                       // value={formData.price}
//                       // placeholder={lang1("t5")}
//                       type="number"
//                     />
//                   </div>
//                   <div className="col-md-6 col-sm-12">
//                     <legend className="fw-semibold opacity-50">Stock </legend>

//                     <MyInput
//                       // label={lang1("t6")}
//                       handleChange={handleChange}
//                       required={true}
//                       id="stock"
//                       name="stock"
//                       // value={formData.stock}
//                       // placeholder={lang1("t6")}
//                       type="number"
//                     />
//                   </div>
//                 </div>

//                 <GoogleReCaptchaProvider
//                   reCaptchaKey={config.googleReCaptchaClientId}
//                 >
//                   <GoogleReCaptcha
//                     className="google-recaptcha-custom-class"
//                     onVerify={onVerify}
//                     refreshReCaptcha={refreshReCaptcha}
//                   />
//                 </GoogleReCaptchaProvider>

//                 <div className="d-flex justify-content-end ">
//                   <button
//                     className="btn btn-danger me-2"
//                     type="button"
//                     onClick={() => navigate(-1)}
//                   >
//                     {/* {lang1("cancel")} */}
//                     Cancel
//                   </button>
//                   <button
//                     className="btn btn-primary"
//                     type="submit"
//                     disabled={submitted}
//                   >
//                     {/* {submitted ? lang1("submit.loading") : lang1("submit")} */}
//                     {submitted ? "loading" : "Submit"}
//                   </button>
//                 </div>
//               </fieldset>
//             </form>
//           </div>
//         </div>
//       </main>

//       <div
//         className="modal fade"
//         id="addCategoryModal"
//         tabIndex="-1"
//         aria-labelledby="addCategoryModalLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="addCategoryModalLabel">
//                 {/* {type === "add" ? "Add Product" : "Edit Product"} */}
//               </h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               ></button>
//             </div>
//             <form onSubmit={handleSubmitCategory}>
//               <div className="modal-body">
//                 <div className="mb-3">
//                   <label htmlFor="categoryName" className="form-label">
//                     Category Name
//                   </label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     id="categoryName"
//                     name="name"
//                     value={categoryName}
//                     onChange={(e) => setCategoryName(e.target.value)}
//                   />
//                 </div>

//                 {/* Add more fields as needed */}
//               </div>
//               <div className="modal-footer">
                // <button
                //   type="button"
                //   className="btn btn-danger"
                //   data-bs-dismiss="modal"
                // >
                //   Close
                // </button>
//                 <button
//                   type="submit"
//                   className="btn btn-primary"
//                   disabled={!categoryName}
//                   // onClick={handleSaveChanges}
//                 >
//                   Submit
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </Dashboard>
//   );
// };
